<template>
  <section id="tugas" class="py-16 bg-secondary">
    <span id="presensi"></span>
    <div class="container mx-auto px-5 lg:px-6 max-w-[1380px]">
      <!-- Header Section -->
      <div class="text-center mb-12" data-aos="fade-down">
        <h2 class="text-3xl font-bold text-primary mb-4">
          Pengumpulan Tugas
        </h2>
        <p class="text-gray-600 max-w-2xl mx-auto">
          Silakan lengkapi tugas Anda melalui form yang telah disediakan
        </p>
      </div>

      <!-- Grid Layout untuk 3 Cards -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        <!-- Card 1: Tugas Individu -->
        <div
          class="bg-white p-6 rounded-xl shadow text-center hover:shadow-lg transition-shadow duration-300 flex flex-col justify-between"
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <div>
            <h2 class="text-2xl font-bold text-primary mb-4">Tugas Individu</h2>
            <p class="text-gray-600 mb-6">
              Kumpulkan tugas individu Anda melalui link berikut
            </p>
          </div>
          <div>
            <a
              href="https://forms.gle/cVGgVQ4UkMXVEbvD8"
              target="_blank"
              rel="noopener noreferrer"
              class="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200"
            >
              <span class="inline-flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-5 h-5"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12-3-3m0 0-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                  />
                </svg>
                Submit Tugas
              </span>
            </a>
            <p class="text-gray-500 text-sm mt-4">
              Pastikan mengumpulkan sebelum deadline yang ditentukan
            </p>
          </div>
        </div>

        <!-- Card 2: Pendataan PDDikti -->
        <div
          class="bg-white p-6 rounded-xl shadow text-center hover:shadow-lg transition-shadow duration-300 flex flex-col justify-between"
          data-aos="zoom-in"
          data-aos-delay="300"
        >
          <div>
            <h2 class="text-2xl font-bold text-primary mb-4">Pendataan PDDikti</h2>
            <p class="text-gray-600 mb-6">
              Pendataan data diri mahasiswa baru untuk PDDikti (KTP, Akte Kelahiran, dan KK)
            </p>
          </div>
          <div>
            <a
              href="https://utdi.id/pendataanpddikti"
              target="_blank"
              rel="noopener noreferrer"
              class="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200"
            >
              <span class="inline-flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-5 h-5"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z"
                  />
                </svg>
                Isi Form PDDikti
              </span>
            </a>
            <p class="text-gray-500 text-sm mt-4">
              Siapkan berkas KTP, Akte Kelahiran, dan KK
            </p>
          </div>
        </div>

        <!-- Card 3: Tugas Kelompok -->
        <div
          class="bg-white p-6 rounded-xl shadow text-center hover:shadow-lg transition-shadow duration-300 flex flex-col justify-between"
          data-aos="zoom-in"
          data-aos-delay="400"
        >
          <div>
            <h2 class="text-2xl font-bold text-primary mb-4">Tugas Kelompok</h2>
            <p class="text-gray-600 mb-6">
              Unggah hasil kerja kelompok Anda melalui link berikut
            </p>
          </div>
          <div>
            <a
              href="https://forms.gle/UvR2J8PZ4xJZNT287"
              target="_blank"
              rel="noopener noreferrer"
              class="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200"
            >
              <span class="inline-flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-5 h-5"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
                  />
                </svg>
                Submit Kelompok
              </span>
            </a>
            <p class="text-gray-500 text-sm mt-4">
              Pastikan seluruh anggota kelompok tercantum dalam pengumpulan
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useHead } from "@vueuse/head";

// Define page-specific metadata
useHead({
  title: "PESONA 2026 - UTDI | Pengumpulan Tugas",
  meta: [
    {
      name: "description",
      content:
        "Pengumpulan tugas individu, pendataan data diri PDDikti, dan tugas kelompok untuk kegiatan PESONA 2026 - Universitas Teknologi Digital Indonesia (UTDI).",
    },
    {
      property: "og:title",
      content: "PESONA 2026 - UTDI | Pengumpulan Tugas",
    },
    {
      property: "og:description",
      content:
        "Pengumpulan tugas individu, pendataan data diri PDDikti, dan tugas kelompok untuk kegiatan PESONA 2026 - Universitas Teknologi Digital Indonesia (UTDI).",
    },
    {
      name: "keywords",
      content:
        "tugas PESONA UTDI, pendataan pddikti, tugas individu, tugas kelompok, form pengumpulan PESONA 2026",
    },
  ],
});
</script>
